<template>

  <section class="chinning section-wrap">
    <div class="container container_1" v-if="exerciseParams">
      <div class="chinning__header section-header">
        <div class="chinning__title-group title-group">
          <h1 class="news-detail__title text-32 text-semibold">
            {{ exerciseParams.exercise.name }}
          </h1>
          <a
              class="news-detail__button text-15 text-bold text-button button-common"
              :href="'/umnaya_sportivnaya_ploshchadka/' + exerciseParams.programCode"
          >
            <div @click="$router.back()">
              Назад
            </div>
          </a>

        </div>
      </div>
      <h2 class="chinning__mobititle main-title main-title--large">
        {{ exerciseParams.exercise.name }}
      </h2>
      <div class="chinning__content">

        <div class="chinning__collection">

          <template v-if="exerciseParams.exercise.animationVideo">
            <div class="training-card">
              <div class="training-card__img">
                <video width="590"
                       controls=""
                       :alt="exerciseParams.exercise.name"
                       :src="exerciseParams.exercise.animationVideo">
                  <source :src="exerciseParams.exercise.animationVideo" type="video/mp4">
                </video>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="training-card training-card--bottom"
                 :style="{'background-color': exerciseParams.exercise.color[0]}">
              <div class="training-card__img">
                <img :src="exerciseParams.exercise.animation" :alt="exerciseParams.exercise.name">
              </div>
            </div>
          </template>



          <template
              v-if="false">
            <table class="chinning__table table text-15"
                   v-for="table in exerciseParams.exercise.tables" :key="table.id" v-html="table.TEXT">
            </table>
          </template>

        </div>

        <div class="chinning__text-group">

          <div class="chinning__descr main-descr main-descr--black"
               v-html="exerciseParams.exercise.description">
          </div>
          <template
              v-if="exerciseParams.currentExerciseIndex + 1 < exerciseParams.exercises.length">
            <a class="news-detail__button text-15 text-bold text-button button-common"
               :href="'/umnaya_sportivnaya_ploshchadka/' + exerciseParams.programCode + '/' + exerciseParams.exercises[exerciseParams.currentExerciseIndex + 1].code">
              Следующее упражнение
            </a>
          </template>

        </div>

      </div>
      <div class="chinning__exerciser exerciser">
        <div class="exerciser__title main-title main-title--large">Тренажер, используемый для упражнения</div>

        <div class="exerciser__content">
          <div class="exerciser__card">
            <div class="exerciser__img">
              <picture>
                <source :srcset="exerciseParams.exercise.machine[0].photo">
                <img :src="exerciseParams.exercise.machine[0].photo" :alt="exerciseParams.exercise.machine[0].name">
              </picture>
            </div>
            <div class="exerciser__name">
              {{ exerciseParams.exercise.machine[0].name }}
            </div>
          </div>
          <div class="exerciser__description-block">
            <h3 class="exerciser__description-title">
              Описание
            </h3>
            <div class="exerciser__description" v-html="exerciseParams.exercise.machine[0].description">
            </div>
          </div>
        </div>
      </div>
  </section>

</template>

<script>

export default {
  name: 'ExerciseView',
  components: {},
  data() {
    return {
      programSections: [],
      exerciseParams: {},
    }
  },
  beforeMount() {
    console.log(this);
    let that = this;

    this.axios.get('https://sfsi.ru/api/smart-workout/all')
        .then((response) => {
          that.programSections = response.data;
          let sections = response.data;
          sections.forEach((section) => {
            let programs = section.programs;
            programs.forEach((program) => {
              if (that.$route.params.programCode == program.code) {
                that.exerciseParams.programCode = program.code;
                that.exerciseParams.program = program;
                let exercises = program.exercises
                that.exerciseParams.exercises = exercises;
                let exerciseCounter = 0;
                exercises.forEach((exercise) => {
                  if (that.$route.params.exerciseCode == exercise.code) {
                    that.exerciseParams.exerciseCode = exercise.code;
                    that.exerciseParams.exercise = exercise;
                    that.exerciseParams.currentExerciseIndex = exerciseCounter;
                    that.$forceUpdate();
                  }
                  exerciseCounter++;
                })
              }
            })
          })
        })

  },
}
</script>
